import { BaseDialog, Button, CustomerTable, HookedForm, InputField } from '@app/components';
import { usePermissions } from '@app/contexts/PermissionContext.tsx';
import ArrowBackIcon from '@app/assets/icons/back.svg?react';
import CloseIcon from '@app/assets/icons/close.svg?react';
import PencilIcon from '@app/assets/icons/pencil.svg?react';
import TagIcon from '@app/assets/icons/tag.svg?react';
import { useTagViewPage } from './TagView.hooks';

export const TagView = () => {
  const {
    navigate,
    tag,
    tagCustomers,
    isLoadingCustomers,
    refetchCustomers,
    customerQuery,
    handleNextPage,
    handlePrevPage,
    handleLimit,
    renameOpen,
    setRenameOpen,
    renameForm,
    handleRename,
    isPending,
  } = useTagViewPage();
  const { can } = usePermissions();

  return (
    <>
      <div>
        <div className="bg-white border-b border-b-base-ghostWhite ">
          <div className="container mx-auto">
            <div className="flex justify-between items-center p-4">
              <h2 className="font-bold text-[28px]">
                <button onClick={() => navigate('/customers/tags')} className="mr-2">
                  <ArrowBackIcon />
                </button>
                {tag?.name}
              </h2>
            </div>
          </div>
        </div>
        <div className="container mx-auto p-4">
          <div className="grid grid-cols-1 md:grid-cols-8 gap-4">
            <div className="bg-white p-4 h-fit col-span-1 md:col-span-3">
              <div className="flex items-center justify-between">
                <h5 className="font-bold text-sm">Tag Information</h5>
                {can('editLists') && (
                  <button onClick={() => setRenameOpen(true)} className="bg-base-antiFlash p-2 rounded-lg">
                    <PencilIcon />
                  </button>
                )}
              </div>
              <hr className="my-4" />
              <table>
                <tbody>
                  <tr>
                    <td className="w-[130px]">
                      <span className="text-xs text-base-coolGray">TAG ID</span>
                    </td>
                    <td>
                      <span className="text-sm font-medium">{tag?.id}</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="w-[130px]">
                      <span className="text-xs text-base-coolGray">TAG NAME</span>
                    </td>
                    <td>
                      <span className="text-sm font-medium">{tag?.name}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="bg-white p-4 col-span-1 md:col-span-5 h-fit">
              {isLoadingCustomers && <div>Loading customers...</div>}
              {!isLoadingCustomers && (
                <CustomerTable
                  simplified
                  currentPage={customerQuery.page}
                  customers={tagCustomers?.customers ?? []}
                  handleNextPage={handleNextPage}
                  handleLimitChange={handleLimit}
                  handlePrevPage={handlePrevPage}
                  refetch={refetchCustomers}
                  totalCustomers={tagCustomers?.count ?? 0}
                  handleCustomerSelection={() => {}}
                  hideCheckboxes={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <BaseDialog size="max-w-2xl" open={renameOpen} onClose={() => setRenameOpen(false)}>
        <div className="border-b border-b-base-ghostWhite p-6 mb-6 flex gap-2 items-start justify-between">
          <div className="bg-base-antiFlash flex items-center p-2 rounded-lg">
            <TagIcon width={24} height={24} />
          </div>
          <div className="mr-auto">
            <h5 className="font-bold text-lg">Update Tag</h5>
            <p className="text-base-coolGray text-sm">Customers are added to a tag from their customer page</p>
          </div>
          <div>
            <button type="button" onClick={() => setRenameOpen(false)}>
              <CloseIcon />
            </button>
          </div>
        </div>
        <div className="px-6 pb-4">
          <HookedForm formHook={renameForm} onSubmit={handleRename} className="space-y-4">
            <InputField name="name" label="Name" />
            <div className="flex items-center gap-4 justify-center ">
              <Button kind="secondary" className="w-full" type="button" onClick={() => setRenameOpen(false)}>
                Cancel
              </Button>
              <Button disabled={isPending} loading={isPending} className="w-full" type="submit">
                Update Tag
              </Button>
            </div>
          </HookedForm>
        </div>
      </BaseDialog>
    </>
  );
};
